import React, { FC, useRef } from 'react';
import s from './collectionArtistsList.module.scss';
import { useGetArtistsInfiniteList } from '@services/artist/hooks/useGetArtistList';
import { InfinityList } from '@components/InfinityList/InfinityList';
import { ArtistSmallCard } from '@components/Cards/ArtistSmallCard/ArtistSmallCard';
import cn from 'classnames';
import { useTranslation } from '@hooks/useTranslation';
type CollectionArtistsListProps = {
  collectionId: number;
  className?: string;
};
const limit = 5;
export const CollectionArtistsList: FC<CollectionArtistsListProps> = ({
  collectionId,
  className
}) => {
  const enabledRef = useRef(false);
  const {
    translate: tr
  } = useTranslation();
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    status
  } = useGetArtistsInfiniteList({
    limit,
    collectionId
  }, {
    enabled: enabledRef.current
  });
  return <div className={cn(s.collectionArtistsList, className)} data-sentry-component="CollectionArtistsList" data-sentry-source-file="CollectionArtistsList.tsx">
            <h4 className={s.collectionArtistsList__title}>{tr({
        id: 'artists.page.title'
      })}</h4>

            <InfinityList data={data} fetchNextPage={fetchNextPage} hasNextPage={hasNextPage} isFetchingNextPage={isFetchingNextPage} status={status} listClassName={s.collectionArtistsList__list} enabledRef={enabledRef} data-sentry-element="InfinityList" data-sentry-source-file="CollectionArtistsList.tsx">
                {({
        profile
      }) => {
        return <ArtistSmallCard className={s.collectionArtistsList__card} key={profile?.shortid} shortid={profile?.shortid} name={profile?.name} surname={profile?.surname} />;
      }}
            </InfinityList>
        </div>;
};